import { Injectable } from "@angular/core";
import { AppSettings } from "../../../../app.settings";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class LlmRunService {

     Base_url =  `${AppSettings.EMAIL_API_ENDPOINT}`;

     All_llm_url =  this.Base_url+'/rerun/all';
     config_url = this.Base_url+'/config';

     constructor(private http: HttpClient) { }


     runAllLLM(config_id:any,source_type:any){
       return this.http.post(this.All_llm_url+'/'+config_id+'/email/'+source_type,{});
     }

     getCofig(){
        return this.http.get(this.config_url);
     }

}